import { useMutation, useQueryClient } from "react-query";
import { addEmployees } from "../../../../../actions/Employees";
import { toast } from "../../../../../components/toastNotification";
import { useSetRecoilState } from "recoil";
import {
  empAddState,
  isSavingEmployees,
  showDataModalState,
  employeeDataState,
} from "../atoms/atoms";
import useSendEmail from "./useSendEmail";
import useSendHierarchyEmail from "modules/CarrierAgreementMgmt/Hierarchy/hooks/useSendHierarchyEmail";
const useAddEmployees = (onSaveSuccess) => {
  const setAddState = useSetRecoilState(empAddState);
  const setShowDataModal = useSetRecoilState(showDataModalState);
  const setEmployeeData = useSetRecoilState(employeeDataState);
  const queryClient = useQueryClient();
  const setIsSaving = useSetRecoilState(isSavingEmployees);
  const { mutateAsync: sendEmail } = useSendEmail();
  const { mutateAsync: sendHierarchyEmail } = useSendHierarchyEmail();

  const invalidateEmployeeQueries = () => {
    queryClient.invalidateQueries("GetAllEmployees");
    queryClient.invalidateQueries("Employee");
    queryClient.invalidateQueries("GetEmployees");
  };

  //Add new carrier function
  const { mutate } = useMutation((newEmp) => addEmployees({ ...newEmp }), {
    onSuccess: (res) => {
      if (res.data === "duplicateEmpNumber") {
        toast.fire(
          "Adding new Employee failed",
          "Employee Number already exists",
          "error"
        );
        setIsSaving(false);
      } else if (res.data === "duplicateUPN") {
        toast.fire(
          "Adding new Employee failed",
          "Employee UPN already exists",
          "error"
        );
        setIsSaving(false);
      } else if (res.status === 201 || res.status === 200) {
        toast.fire("Success", "New Employee added successfully", "success");
        sendEmail(res.data, {
          onSuccess: (res) => {
            if (res) {
              if (res.status === 400) {
                toast.fire(
                  "Success",
                  "New Employee Added Successfully, but failed in sending email",
                  "warning"
                );
              } else {
                toast.fire(
                  "Success",
                  "New Employee added successfully",
                  "success"
                );
              }
            }
          },
        });

        if (!!res.data.hierarchyData) {
          sendHierarchyEmail(res.data.hierarchyData, {});
        }

        const addedData = res?.data?.employeeAddedData;
        if (addedData) {
          setEmployeeData({
            recordId: addedData.employeeId,
            fullName: addedData.fullname,
          });
          setShowDataModal(true);
        }

        invalidateEmployeeQueries();
        setIsSaving(false);
        setAddState(false);
        onSaveSuccess();
      } else {
        toast.fire(
          "Adding new Employee failed",
          "Server Error: Cannot add new Employee",
          "error"
        );
        setIsSaving(false);
      }
      invalidateEmployeeQueries();
    },
    onError: (error) => {
      if (
        error.response.data.message === "Failed sending of email" ||
        error.response.data.message === "Failed inserting of notification"
      ) {
        toast.fire(
          "Success",
          "New Employee added successfully, but " + error.response.data.message,
          "warning"
        );
        invalidateEmployeeQueries();
      } else {
        toast.fire(
          "Adding new Employee failed",
          "Server Error: Cannot add new Employee",
          "error"
        );
      }
      invalidateEmployeeQueries();
    },
  });
  return mutate;
};
export default useAddEmployees;
